import { OrganizationTypeKind } from '../swagger-api/model/organizationTypeKind';

export default class FormsHelpers {
  public static readonly notCustomOrganizationTypes: string[] = Object.values(OrganizationTypeKind).filter(
    (key: string) => key !== OrganizationTypeKind.Custom,
  );
}

export function setDropdownWidth(className: string, popupId?: string): void {
  const inputElement: HTMLElement = document.querySelector(className);
  if (inputElement) {
    const dropdownWidth: number = inputElement.offsetWidth;
    const dropdownElement: HTMLElement | NodeListOf<HTMLElement> = popupId
      ? document.getElementById(popupId)
      : document.querySelectorAll('.dropDownMenu');
    if (dropdownElement instanceof HTMLElement) {
      dropdownElement.style.width = dropdownWidth.toString() + 'px';
    }
    if (dropdownElement instanceof NodeList) {
      dropdownElement.forEach((item: HTMLElement) => (item.style.width = dropdownWidth.toString() + 'px'));
    }
  }
}

export function getNewPlaceholderForMobile(id: string, placeholder: string): string {
  switch (id) {
    case 'community_id-post':
      return 'FORM_CONSTRUCTOR_POST_TO_COMMUNITY_PLACEHOLDER_MOBILE';
    case 'project_id-post':
      return 'FORM_CONSTRUCTOR_POST_TO_PROJECT_PLACEHOLDER_MOBILE';
    case 'location-community':
      return 'FORM_CONSTRUCTOR_LOCATION_PLACEHOLDER_MOBILE';
    case 'linked_communities-community':
      return 'FORM_CONSTRUCTOR_COMMUNITY_LINKED_COMMUNITIES_PLACEHOLDER_MOBILE';
    case 'location-project':
      return 'FORM_CONSTRUCTOR_PROJECT_LOCATION_PLACEHOLDER_MOBILE';
    case 'linked_projects-project':
      return 'FORM_CONSTRUCTOR_PROJECT_LINKED_PROJECTS_PLACEHOLDER_MOBILE';
    case 'community_id-project':
      return 'FORM_CONSTRUCTOR_PROJECT_COMMUNITY_PLACEHOLDER_MOBILE';
    case 'linked_organizations-project':
      return 'FORM_CONSTRUCTOR_PROJECT_ORGANIZATIONS_PLACEHOLDER_MOBILE';
    case 'location-profile':
      return 'FORM_CONSTRUCTOR_PROFILE_ADDITIONAL_LOCATION_PLACEHOLDER_MOBILE';
    case 'alternative_names-organization':
      return 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_ALTERNATIVE_NAMES_PLACEHOLDER_MOBILE';
    case 'place_of_birth-patient':
      return 'FORM_CONSTRUCTOR_PROFILE_PATIENT_PLACE_OF_BIRTH_PLACEHOLDER_MOBILE';
    case 'insurance_carrier_text-patient':
      return 'FORM_CONSTRUCTOR_PROFILE_PATIENT_INSURANCE_CARRIER_PLACEHOLDER_MOBILE';
    case 'education-doctor':
      return 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_EDUCATION_PLACEHOLDER_MOBILE';
    case 'education-med_staff':
      return 'FORM_CONSTRUCTOR_PROFILE_DOCTOR_EDUCATION_PLACEHOLDER_MOBILE';
    case 'organization_which_represented-doctor':
      return 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_WHICH_REPRESENTED_PLACEHOLDER_MOBILE';
    case 'organization_which_represented-researcher':
      return 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_WHICH_REPRESENTED_PLACEHOLDER_MOBILE';
    case 'organization_which_represented-med_staff':
      return 'FORM_CONSTRUCTOR_PROFILE_ORGANIZATION_WHICH_REPRESENTED_PLACEHOLDER_MOBILE';
    case 'treatment_of_diseases-doctor':
      return 'FORM_CONSTRUCTOR_PROFILE_DISEASES_PLACEHOLDER_MOBILE';
    case 'diseases-researcher':
      return 'FORM_CONSTRUCTOR_PROFILE_DISEASES_PLACEHOLDER_MOBILE';
    case 'treatment_of_diseases-med_staff':
      return 'FORM_CONSTRUCTOR_PROFILE_DISEASES_PLACEHOLDER_MOBILE';
    default:
      return placeholder;
  }
}

export function getDiseaseTooltipMessage(id: string): string {
  if (id.includes('special')) {
    return 'Cannot find your specialty? Please ';
  } else if (id.includes('diseas')) {
    return 'Cannot find your diseases? Please ';
  } else {
    return '';
  }
}

export function getOrganizationProjectTooltipTitle(id: string): string {
  return id === 'linked_organizations-project'
    ? 'Type to search and select organizations associated with this project'
    : '';
}
